import { apiClient } from 'client/core/network/apiClient';
import { ICaptchaToken } from 'server/captcha/CaptchaService';

export const CaptchaWidgetApi = {
  getCaptcha: () => apiClient.get(`/captcha/`)
};
